import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import 'react-datepicker/dist/react-datepicker.css';
import { FaPlus, FaPaperclip } from 'react-icons/fa';
import { toast } from 'react-hot-toast';
import PermissionAllowed from 'ui-component/permissions/PermissionAllowed';
import { FaRegTrashCan } from 'react-icons/fa6';
import EstimateDetailInvoice from './EstimateDetailInvoice';
import PaymentsComponent from './paymentComponents/PaymentsComponent';
import { LuChevronDown, LuChevronUp } from 'react-icons/lu';
import { Dropdown } from 'react-bootstrap';
import { saveAs } from 'file-saver';
import Notes from 'ui-component/notes';
import PrivacyModeContent from 'ui-component/PrivacyModeContent';
import ActionConfirmationModal from 'ui-component/confirmation-dialogs/actionConfirmationModal/ActionConfirmationModal';
import { PiInfoFill } from 'react-icons/pi';
import { getCurrencySymbol, numberFormatter } from 'utils/currency';
import { useQuery, useQueryClient } from 'react-query';
import AcceptOrderModal from 'ui-component/confirmation-dialogs/acceptOrderModal/AcceptOrderModal';
import DeleteConfirmation from 'ui-component/confirmation-dialogs/deleteConfirmation/DeleteConfirmation';
import agreementImage from 'assets/images/agreement.svg';
import StatusBadge from 'ui-component/StatusBadge';
import PdfViewer from 'ui-component/PdfViewer';


import SendEmailModal from './modals/SendEmailModal';
import PurchaseOrderModal from './modals/PurchaseOrderModal';
import TimelineStep from 'ui-component/TimelineStep';
import { Skeleton } from '@mui/material';
import { CommonDateOnlyFormat } from 'helpers/common.helper';

import usePermissions from 'hooks/usePermissions';
import { RegisterPaymentIcon, DeleteIcon, SettingsDownloadIcon, PlusIcon, InfoIcon } from 'ui-component/custom-icons/icons';
import InvoiceComponent from './components/InvoiceComponent';
import QoutationComponent from './components/QoutationComponent';
import SalesOrderComponent from './components/SalesOrderComponent';
import ShipmentsComponent from './components/ShipmentsComponent';
import CreditPaymentComponent from './components/CreditPaymentComponent';
import PurchaseOrderComponent from './components/PurchaseOrderComponent';
import Timeline from 'ui-component/Timeline';
import useIsMobile from 'utils/isMobileUtils';
import SendEmailModalMobile from './modals/SendEmailMobileModal';
import { useDropzone } from 'react-dropzone';
import ChangeStatusMobileModal from './paymentComponents/ChangeStatusModal';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import InsertPhotoOutlinedIcon from '@mui/icons-material/InsertPhotoOutlined';

import usePageTitle from 'hooks/usePageTitle';

// ✅ Clear
const EstimationDetails = () => {
	const { id } = useParams();
	const [userName] = useSelector((state) => [state.main.user.first_name + ' ' + state.main.user.last_name]);
	

	const selectedCurrency = useSelector((state) => state.main.selectedCurrency);

	const [allPermissions, hasEveryPermission] = usePermissions();

	// Customer Create
	const [selectedEstimate, setSelectedEstimate] = useState();
	const [salesTypePath, setSalesTypePath] = useState('');
	const [salesType, setSalesType] = useState('');
	const [showActions, setShowActions] = useState(false);
	const [showDeletePopup, setShowDeletePopup] = useState(false);
	const [showDeleteInvoicePopup, setShowDeleteInvoicePopup] = useState(false);
	const [showDeleteQuotationPopup, setShowDeleteQuotationPopup] = useState(false);
	const [showDeleteCreditNotePopup, setShowDeleteCreditNotePopup] = useState(false);
	const [openSendEmailPopup, setOpenSendEmailPopup] = useState(false);
	const [sendingEstimate, setSendingEstimate] = useState(false);
	const [selectedForSending, setSelectedForSending] = useState('');
	const [showPurchaseOrderModal, setShowPurchaseOrderModal] = useState(null);
	const [purchaseOrderItems, setPurchaseOrderItems] = useState(null);
	const [showCancelPopup, setShowCancelPopup] = useState(false);
	const [selectedPaymentId, setSelectedPaymentId] = useState(null);
	const [showDeletePayment, setShowDeletePayment] = useState(false);
	const [showCompletePopup, setShowCompletePopup] = useState(false);
	const [completingInvoice, setCompletingInvoice] = useState(false);
	const [refreshTimelineKey, setRefreshTimelineKey] = useState(0);
	const [totalProductOverviewItems, setTotalProductOverviewItems] = useState(0);
	const [inProgressFileUploadCollection, setInProgressFileUploadCollection] = useState([]);
	const [removeFilenameFromInProgressFileUploadCollection, setRemoveFilenameFromInProgressFileUploadCollection] = useState(null);
	
	const currentDate = moment().format('YYYY-MM-DD');

	const statusAllowedToDeleteDraft = ['Draft'];
	const statusAllowedToComplete = ['Completed', 'Paid'];
	const statusAllowedToPayAndSalesOrder = ['Draft', 'Completed'];
	const statusAllowedToAccept = ['Pending', 'Pending Manager'];
	const statusAllowedToCancel = ['Open', 'Pending Manager', 'Pending'];

	const dispatch = useDispatch();

	// End Create
	const history = useNavigate();
	const [modalPrice, setModalprice] = useState('00');

	const [shippingRow, setShippingrow] = useState({
		quantity: 1,
		unitPrice: 0,
		totalPrice: 0
	});

	const [selectedCustomerinfo, setSelectedCustomerInfo] = useState({});
	const [subTotal, setSubtotal] = useState('00');
	const [paymentData, setPaymentData] = useState([]);
	const [deleteMessage, setDeleteMessage] = useState('');

	const [orderAgreementsData, setOrderAgreementsData] = useState([]);
	const [selectedPaymentShipment, setSelectedPaymentShipment] = useState('payment');
	const queryClient = useQueryClient();
	const params = useParams();
	const location = useLocation();
	const pathParts = location.pathname.split('/');
	const mainPath = pathParts.slice(0, 3).join('/');
	const [isExtraDropdownOpen, setIsExtraDropdownOpen] = useState(false);
	const [refreshKey, setRefreshKey] = useState(0);

	
	const queryParams = new URLSearchParams(location.search);

	const openSendEmailModal = (type) => {
		setOpenSendEmailPopup(type);
	};

	const closeSendEmailPopup = () => {
		setOpenSendEmailPopup(false);
	};


	const { data: requestData } = useQuery(
		['estimation-details', id, location, salesTypePath, showActions, refreshKey],
		() => {
			const queryParams = new URLSearchParams(location.search);
			if (mainPath == '/sales/estimates' || mainPath == '/sales/quotations') {
				setShowActions(true);
				return api.getQoutationById(id);
			} else {
				setShowActions(true);
				return api.getEstimationById(id);
			}
		},
		{
		}
	);

	const invalidateEstQuery = () => {

		queryClient.prefetchQuery({ queryKey: ['estimation-details', id, location, salesTypePath, showActions] });
	};

	const [showAddPaymentModal, setShowAddPaymentModal] = useState(false);

	const [confirmationDialog, setConfirmationDialog] = useState({
		show: false,
		message: '',
		title: '',
		handleConfirm: () => {},
		handleClose: () => {}
	});

	const handleCloseConfirmationDialog = () => {
		setConfirmationDialog({
			show: false,
			message: '',
			title: '',
			handleConfirm: () => {},
			handleClose: () => {}
		});
	};

	const handleCloseDeletePopup = () => setShowDeletePopup('');

	const handleSendEstimateEmail = (data) => {
		setSendingEstimate(true);
		toast.promise(
			api.sendEstimateByEmail(data).then(
				(res) => {
					invalidateEstQuery();
					if (res.status) {
						setRefreshKey(oldKey => oldKey + 1);
						setOpenSendEmailPopup(false);
					} else {
						toast.error(`Sending email failed. Please try again.`);
					}
					setSendingEstimate(false);

					return res?.status ? res : null;
				},
				() => {}
			),
			{
				loading: `Sending...`,
				success: (data) => `${data.message}`,
				error: <b>Failed to send email</b>
			}
		);
	};

	const handleCompleteInvoice = (id) => {

		setCompletingInvoice(true);
		toast.promise(
			api.completeInvoice(id).then(
				(res) => {
					invalidateEstQuery();
					setShowCompletePopup(false)
					if (res.status) {
						setRefreshKey(oldKey => oldKey + 1);
						setOpenSendEmailPopup(false);
					} else {
						toast.error(`Completing invoice failed. Please try again.`);
					}
					setCompletingInvoice(false);

					return res?.status ? res : null;
				},
				() => {}
			),
			{
				loading: `Processing...`,
				success: (data) => `${data.message}`,
				error: <b>Failed to process invoice</b>
			}
		);
	}

	const handleAddPayment = (data) => {

		setRefreshKey(oldKey => oldKey + 1);
		invalidateEstQuery();
		setRefreshTimelineKey(oldKey => oldKey + 1);
	};

	const handlePaymentToggle = (index) => {
		setPaymentData((oldData) =>
			oldData?.map((p, i) =>
				i == index
					? {
							...p,
							expand: p?.expand ? false : true
					  }
					: p
			)
		);
	};


	const closePurchaseOrderPopup = () => {
		setShowPurchaseOrderModal('');
	};

	const handleUpdatePayment = (data) => {

		setRefreshKey(oldKey => oldKey + 1);
		invalidateEstQuery();
	};

	const handleDeletePayment = (data) => {
		toast.promise(
			api.deleteEstimatePayment(selectedPaymentId).then((res) => {
				if (res.status) {
					
					setRefreshKey(oldKey => oldKey + 1);
					handleClose()
					setSelectedPaymentId(null);
					invalidateEstQuery();
					setRefreshTimelineKey(oldKey => oldKey + 1);
				}

				return res?.status == true ? res : null;
			}),

			{
				loading: 'Deleting Payment...',
				success: (data) => `${data.message}`,
				error: <b>Payment Delete Failed</b>
			}
		);
		invalidateEstQuery();
	};


	const deletePayment = (id) => { 
		setShowDeletePayment(true);
		setSelectedPaymentId(id);
	}

	const [estimateRow, setEstimaterow] = useState({
		customer_id: '',
		estimate_number: '',
		sales_manager: '',
		transit_id: '',
		vatStatus: 'Including VAT',
		vatPrice: 21,
		startDate: currentDate,
		expiresIn: 7,
		currency: 'eur',
		notes: []
	});
	// Row Area
	const [rows, setRows] = useState([{ id: 1, modelId: '', type: '', quantity: 0, unitPrice: 0, total: 0 }]);
	


	useEffect(() => {
		setEstimaterow((oldData) => ({ ...oldData, sales_manager: selectedCustomerinfo?.sales_manager_id }));
	}, [selectedCustomerinfo]);

	const [attachmentId, setAttachmentId] = useState(null);
	const [showDeleteAttachment, setShowDeleteAttachment] = useState(false);
	useEffect(() => {
		initiateDatas();

		const subPath = pathParts;
		subPath.pop();

		setSalesTypePath(subPath.join('/'));

		setRefreshKey(oldKey => oldKey + 1);
	}, [location]);


    const downloadAttachment = (attachment) => {
        attachment?.filename && window.open(attachment?.attachment_url, '_blank');
	}
	

	const removeAttachment = (id) => {
		setShowDeleteAttachment(true);
		setAttachmentId(id)
	}
	const handleDeleteAttachment = () => {
		const id = attachmentId;
		api.deleteSalesInvoiceAttachment(id).then((res) => {
			if (res.status) {
				setShowDeleteAttachment(false);
				setAttachmentId(null)
				toast.success(res.message);

				invalidateEstQuery();
				if (res.status) {
					setRefreshKey(oldKey => oldKey + 1);
				} else {
					toast.error(`Deleting attachment failed. Please try again.`);
				}
			} else {
				toast.error(res.message);
			}
		});
	}


	useEffect(() => {
		if (requestData?.data?.data) {
			setSelectedEstimate(requestData?.data?.data);
			if (removeFilenameFromInProgressFileUploadCollection) {
				setInProgressFileUploadCollection((oldData) =>
					oldData.filter((item) => item.filename !== removeFilenameFromInProgressFileUploadCollection)	
				);
				setRemoveFilenameFromInProgressFileUploadCollection(null);
			}
			if (requestData?.data?.data?.payments) {
				setPaymentData([...requestData?.data?.data?.payments]);
			}
			if (requestData?.data?.data?.product_overview) {
				const computeItems = requestData?.data?.data?.product_overview?.reduce((acc, item) => acc + (parseInt(item?.product_stock_comparison?.backorder_qty) + parseInt(item?.product_stock_comparison?.reserved_qty)), 0);
				setTotalProductOverviewItems(computeItems);
			}
			if (salesTypePath == '/sales/estimates' || salesTypePath == '/sales/quotations') {
				setSalesType('estimate');
			} else {
				if (selectedEstimate?.invoice_number != '' && selectedEstimate?.estimation_number != '') {
					setSalesType('invoice');
				} else {
					setSalesType('credit-note');
				}
			}
			
			setOrderAgreementsData(requestData?.data?.data.order_agreements);
		}
	}, [requestData]);

	const [defaultPageTitle, setDefaultPageTitle] = useState('');

	const [setPageTitle] = usePageTitle(defaultPageTitle); // Start with empty
	useEffect(() => {
		setDefaultPageTitle(salesType === 'invoice' ? 'Invoice' : salesType === 'estimate' ? 'Quotation' : '');
	}, [salesType]);
	
	const initiateDatas = () => {
		if (id) {
		} else {
			history(salesTypePath);
		}
	};

	const addNote = (noteInputValue, noteType, mentions, noteInputPlain) => {
		toast.promise(
			api
				.newEstimateNote(id, {
					details: noteInputValue,
					detail_plain: noteInputPlain,
					type: 'public',
					todo: noteType == 'todo' ? true : false,
					mentions
				})
				.then(
					(res) => {
						if (res.status) {
							setEstimaterow((oldData) => ({
								...oldData,
								notes: [
									{
										id: res?.data?.id,
										details: noteInputValue,
										date: moment(res?.data?.created_at).format('YYYY-MM-DD'),
										time: moment(res?.data?.created_at).format('HH:mm'),
										user_name: userName,
										expand: false,
										isDeletable: true
									},
									...oldData?.notes
								]
							}));
						}

						return res?.status ? res : null;
					},
					() => {}
				),
			{
				loading: 'Adding Note...',
				success: (data) => `${data.message}`,
				error: <b>Failed to add note</b>
			}
		);
	};

	const toggleNoteExpand = (index) => {
		setEstimaterow((oldData) => ({
			...oldData,
			notes: oldData?.notes?.map((note, i) =>
				index == i
					? {
							...note,
							expand: !note?.expand
					  }
					: note
			)
		}));
	};

    
    const handleOpenNewTab = (pageModule, id) => {
        let url = '';
        if (pageModule == 'products') {
            url = `/products/${id}`;
        } else if (pageModule == 'contacts') {
            url = `/contacts/${id}`;
        } else if (pageModule == 'purchase_orders') {
            url = `/purchasing/view/${id}`;
        } else if (pageModule == 'sales_orders') {
            url = `/sales/sales-orders/${id}`;
        } else if (pageModule == 'invoices') {
            url = `/sales/invoices/${id}`;
        } else if (pageModule == 'quotations') {
            url = `/sales/quotations/${id}`;
        }
        if (url) {
            history(url);
        }
	};
	
	const removeNote = (index) => {
		toast.promise(
			api.removeEstimateNote(id, estimateRow?.notes?.[index]?.id).then(
				(res) => {
					if (res.status) {
						setEstimaterow((oldData) => ({
							...oldData,
							notes: oldData?.notes?.filter((note, i) => index != i)
						}));
					}

					return res?.status ? res : null;
				},
				() => {}
			),
			{
				loading: 'Deleting Note...',
				success: (data) => `${data.message}`,
				error: <b>Failed to delete note</b>
			}
		);
	};

	useEffect(() => {
		if (selectedEstimate) {
			const expDate = moment(selectedEstimate?.expires_at).format('YYYY-MM-DD');
			let tempRow = selectedEstimate?.estimation_details.map((item, index) => {
				return {
					id: index,
					modelId: item?.product_id,
					type: item?.product?.product_name,
					quantity: item?.qty,
					unitPrice: Number(item?.unit_price),
					total: item?.total_price
				};
			});

			tempRow = [
				...tempRow,
				{
					id: tempRow.length + 1,
					modelId: '',
					type: '',
					quantity: '',
					unitPrice: '',
					total: ''
				}
			];

			setRows(tempRow);
			setSelectedCustomerInfo(selectedEstimate.customer);
			setSubtotal(selectedEstimate?.subtotal);

			const temEstimate = {
				estimate_number: selectedEstimate?.estimation_number,
				customer_id: selectedEstimate?.customer_id,
				startDate: selectedEstimate?.start_date,
				expiryDate: expDate,
				transit_id: selectedEstimate?.transit_company?.id,
				sales_manager: selectedEstimate?.sales_person?.id,
				private_note: selectedEstimate?.private_note,
				vatStatus: selectedEstimate?.vat_type,
				vatPrice: selectedEstimate?.vat_percent || 21,
				currency: selectedEstimate?.currency,
				private_note: selectedEstimate?.private_note,
				expiresIn: moment(selectedEstimate?.expires_at).diff(selectedEstimate?.start_date, 'days')
			};

			let notesArray = [];

			selectedEstimate?.notes?.forEach((note) => {
				notesArray = [
					{
						id: note?.id,
						details: note?.details,
						date: moment(note?.created_at).format('YYYY-MM-DD'),
						time: moment(note?.created_at).format('HH:mm'),
						user_name: `${note?.user_created?.first_name} ${note?.user_created?.last_name}`,
						expand: false,
						isDeletable: note?.is_deletable
					},
					...notesArray
				];
			});

			notesArray = _.sortBy(notesArray, (n) => -n.id);

			setEstimaterow({ ...temEstimate, notes: notesArray });
		}
	}, [selectedEstimate]);

	const calculateTotal = () => {
		let total = 0;
		let grandTotal = 0;
		for (let i = 0; i < rows.length; i++) {
			const { quantity, unitPrice } = rows[i];
			total += parseFloat(quantity || 0) * parseFloat(unitPrice || 0);
		}

		if (shippingRow?.totalPrice > 0) {
			const shippingTotal = parseFloat(shippingRow.totalPrice);
			grandTotal = total + shippingTotal;
		} else {
			grandTotal = total;
		}

		if (isNaN(grandTotal)) {
			return { subtotal: '00', modelTotal: '00' };
		}
		return { subtotal: grandTotal, modelTotal: total };
	};

	useEffect(() => {
		let tempsubtotal = calculateTotal();
		const subTotals = parseFloat(tempsubtotal?.subtotal).toFixed(2);
		const modaltotal = parseFloat(tempsubtotal?.modelTotal).toFixed(2);
		setSubtotal(subTotals);
		setModalprice(modaltotal);
	}, [rows, shippingRow, estimateRow]);

	useEffect(() => {
		if (estimateRow?.vatStatus == 'Excluding VAT' && estimateRow?.vatPrice > 0) {
			let tempvat = (modalPrice * (estimateRow?.vatPrice / 100)).toFixed(2);
			let temTotal = (parseFloat(subTotal) + parseFloat(tempvat)).toFixed(2);
		}
	}, [subTotal, modalPrice, estimateRow]);

	const downloadEstimate = (template, to) => {
		// toast.promise(
		api.downloadEstimate(id, { template, to }).then((res) => {

			var newBlob = new Blob([res], { type: 'application/pdf' });
			saveAs(
				newBlob,
				`${
					selectedEstimate?.transaction_type == 'Invoice'
						? 'Invoice ' + selectedEstimate?.invoice_number
						: 'Quotation ' + selectedEstimate?.estimation_number
				}.pdf`
			);
		});
	};

	// Create Customer


	const handleClose = (data) => {
		setShowCancelPopup(false)
		setShowDeletePayment(false)
		setShowDeleteAttachment(false);
	};

	const [showAcceptPopup, setShowAcceptPopup] = useState(null);


	const handleAcceptConfirm = () => {
		toast.promise(
			api
				.acceptedEstimate({
					estimation_id: selectedEstimate?.id
				})
				.then((res) => {
					if (res.status) {
						setShowAcceptPopup(null);
						invalidateEstQuery();
					}
				}),
			{
				loading: 'Accepting Estimate...',
				success: <b>Estimate Accepted!</b>,
				error: <b>Could not Accept Estimate.</b>
			}
		);
	};

	const acceptOrder = (data) => {
		const id = data.id;
		toast.promise(
			api
				.acceptedEstimate({
					qoutation_id: id
				})
				.then((res) => {
					if (res.status) {
						history(`/sales/sales-orders/${res?.data?.sales_order_id}`);
					}
				}),
			{
				loading: 'Accepting Quotation...',
				success: <b>Quotation Accepted</b>,
				error: <b>Could not accept quotation.</b>
			}
		);
	};
	const createSalesOrder = (data) => {
		const id = data.id;
		toast.promise(
			api
				.createSalesOrderFromInvoice({
					estimation_id: id
				})
				.then((res) => {
					if (res.status) {
						history(`/sales/sales-orders/${res?.data?.sales_order_id}`);
					}
				}),
			{
				loading: 'Creating Sales Order...',
				success: <b>Sales Order Created</b>,
				error: <b>Could not create sales order.</b>
			}
		);
	};

	const billOrder = (data) => {
		const id = data.id;
		toast.promise(
			api
				.approveEstimate({
					qoutation_id: id
				})
				.then((res) => {
					if (res.status) {
						history(`/sales/invoices/${res?.data?.invoice_id}`);
					}
				}),
			{
				loading: 'Creating Invoice...',
				success: <b>Invoice Created</b>,
				error: <b>Could not create invoice.</b>
			}
		);
	};

	const duplicateInvoiceAsInvoice = (id) => {
		toast.promise(
			api
				.duplicateInvoiceAsInvoice(id)
				.then((res) => {
					if (res.status) {
						history(`/sales/invoices/${res?.data?.invoice_id}`);
					}
				}),
			{
				loading: 'Creating Invoice...',
				success: <b>Invoice Created</b>,
				error: <b>Could not create invoice.</b>
			}
		);
	}

	const duplicateInvoiceAsCreditNote = (id) => {
		toast.promise(
			api
				.duplicateInvoiceAsCreditNote(id)
				.then((res) => {
					if (res.status) {
						history(`/sales/invoices/${res?.data?.invoice_id}`);
					}
				}),
			{
				loading: 'Creating Credit Note...',
				success: <b>Credit Note Created</b>,
				error: <b>Could not create credit note.</b>
			}
		);
	}
	const duplicateInvoiceAsSalesOrder = (id) => {
		toast.promise(
			api
				.duplicateInvoiceAsSalesOrder(id)
				.then((res) => {
					if (res.status) {
						history(`/sales/sales-orders/${res?.data?.sales_order_id}`);
					}
				}),
			{
				loading: 'Creating Sales Order...',
				success: <b>Sales Order Created</b>,
				error: <b>Could not create sales order.</b>
			}
		);
	}

	const duplicateCreditNoteAsCreditNote = (id) => {
		toast.promise(
			api
				.duplicateCreditNoteAsCreditNote(id)
				.then((res) => {
					if (res.status) {
						history(`/sales/invoices/${res?.data?.id}`);
					}
				}),
			{
				loading: 'Creating Invoice...',
				success: <b>Invoice Created</b>,
				error: <b>Could not create invoice.</b>
			}
		);
	}
	const duplicateCreditNoteAsInvoice = (id) => {
		toast.promise(
			api
				.duplicateCreditNoteAsInvoice(id)
				.then((res) => {
					if (res.status) {
						history(`/sales/invoices/${res?.data?.id}`);
					}
				}),
			{
				loading: 'Creating Invoice...',
				success: <b>Invoice Created</b>,
				error: <b>Could not create invoice.</b>
			}
		);
	}

	const cancelEstimate = (data) => {
		const id = data.id;
		toast.promise(
			api.cancelEstimation(id).then((res) => {
				if (res.status) {
					invalidateEstQuery();
					history(`/sales/quotations`);
				}
			}),
			{
				loading: 'Canceling Quotation...',
				success: <b>Quotation cancelled</b>,
				error: <b>Could not cancel quotation.</b>
			}
		);
	};

	const cancelInvoice = (data) => {
		const id = data.id;
		toast.promise(
			api.cancelInvoice(id).then((res) => {
				if (res.status) {
					invalidateEstQuery();
					history(`/sales/invoices`);
				}
			}),
			{
				loading: 'Canceling Invoice...',
				success: <b>Invoice cancelled</b>,
				error: <b>Could not cancel invoice.</b>
			}
		);
	};

	const deleteEstimate = (data) => {
		setDeleteMessage(
			`Are you sure you want to delete <br />${salesType == 'estimate' ? 'quotation' : salesType } ${salesType == 'estimate' ? data?.estimation_number : data?.invoice_number}?`
		);
		setShowDeletePopup(data);
	};

	const handleReloadCreditNote = () => {
		invalidateEstQuery();
	};

	const handleDelete = (id) => {
		
		if (salesType == 'estimate') {
			toast.promise(
				api.deleteEstimation(id).then((res) => {
					if (res.status) {
						setRefreshKey(oldKey => oldKey + 1);
						invalidateEstQuery();
						history(`/sales/quotations`);
					}
				}),
				{
					loading: 'Deleting Quotation...',
					success: <b>Quotation deleted</b>,
					error: <b>Could not delete quotation.</b>
				}
			);
		} else {
			toast.promise(
				api.deleteInvoice(id).then((res) => {
					if (res.status) {
						setRefreshKey(oldKey => oldKey + 1);
						invalidateEstQuery();
						history(`/sales/invoices`);
					}
				}),
				{
					loading: 'Deleting Invoice...',
					success: <b>Invoice deleted</b>,
					error: <b>Could not delete Invoice.</b>
				}
			);
		}

	};
	
	const handleDeleteInvoice = () => {
		
		toast.promise(
			api.deleteInvoiceRollbackSequence(selectedEstimate?.id).then((res) => {
				if (res.status) {
					setRefreshKey(oldKey => oldKey + 1);
					invalidateEstQuery();
					history(`/sales/invoices`);
				}
				setShowDeleteInvoicePopup(false)
			}),
			{
				loading: 'Deleting Invoice...',
				success: <b>Invoice deleted</b>,
				error: <b>Could not delete Invoice.</b>
			}
		);

	};

	const handleDeleteQuotation = () => {
		
		toast.promise(
			api.deleteQuotationRollbackSequence(selectedEstimate?.id).then((res) => {
				if (res.status) {
					setRefreshKey(oldKey => oldKey + 1);
					invalidateEstQuery();
					history(`/sales/quotations`);
				}
				setShowDeleteQuotationPopup(false)
			}),
			{
				loading: 'Deleting Quotation...',
				success: <b>Quotation deleted</b>,
				error: <b>Could not delete Quotation.</b>
			}
		);

	};

	const handleDeleteCreditNote = () => {
		
		toast.promise(
			api.deleteCreditNoteRollbackSequence(selectedEstimate?.id).then((res) => {
				if (res.status) {
					setRefreshKey(oldKey => oldKey + 1);
					invalidateEstQuery();
					history(`/sales/invoices`);
				}
				setShowDeleteInvoicePopup(false)
			}),
			{
				loading: 'Deleting Credit Note...',
				success: <b>Credit Note deleted</b>,
				error: <b>Could not delete Credit Note.</b>
			}
		);

	};

	const handleCancel = () => {
		if (salesType === 'invoice') {
			cancelInvoice(selectedEstimate);
		} else {
			cancelEstimate(selectedEstimate);
		}
		setShowCancelPopup(false);
	}


	const exportDataToCsv = () => {
		const request = {
			id: id,
			currency: selectedCurrency
		}
		api.exportInvoiceToCsv(request).then((res) => {
			const newFileName = `Projectmix - Invoice ${selectedEstimate?.invoice_number}`;

			if (res != 404) {
				var newBlob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
				saveAs(newBlob, `${newFileName}.xlsx`);
				toast.success('Downloaded Completed!');
				// );
			} else {
				toast.error(res == 404 ? 'No Records Found!' : 'Download Failed!');
			}


		});
	}


    const allowedExtensions = ['pdf', 'jpeg', 'jpg', 'png'];
    const validateFileExtension = (fileName) => {
        const extension = fileName.split('.').pop().toLowerCase();
        return allowedExtensions.includes(extension);
    };

	const onAttachmentDrop = useCallback((acceptedFiles) => {
		const file = acceptedFiles[0];
		if (!file) return;
		if (!validateFileExtension(file.name)) {
			toast.error('Invalid file extension. Please select a PDF, JPEG, JPG, or PNG file.');
			return;
		}
		if (file.size > 5 * 1024 * 1024) {
			toast.error('File size should not exceed more than 5MB.');
			return;
		}
		let sizeStr = '';
		if (file.size >= 1024 * 1024) {
			sizeStr = (file.size / (1024 * 1024)).toFixed(2) + ' MB';
		} else {
			sizeStr = (file.size / 1024).toFixed(2) + ' KB';
		}
		let values = {
			filename: file.name,
			size: sizeStr,
			extension: file.type,
		}
		setInProgressFileUploadCollection((oldData) => [...oldData, values]);
		// console.log('values', values)
		// setInProgressFileUploadCollection
		uploadAttachment(file);
	}, [selectedEstimate]);

	const { getRootProps: getAttachmentRootProps, getInputProps: getAttachmentInputProps } = useDropzone({ onDrop: onAttachmentDrop });
	

	const uploadAttachment = async (attachment) => {
		const attachmentName = attachment?.name || '';
		const formData = new FormData();
		formData.append('attachment', attachment);
		formData.append('estimation_id', id);
		formData.append('type', 'tt_file');

		let sizeStr = '';
		if (attachment.size >= 1024 * 1024) {
			sizeStr = (attachment.size / (1024 * 1024)).toFixed(2) + ' MB';
		} else {
			sizeStr = (attachment.size / 1024).toFixed(2) + ' KB';
		}
		formData.append('file_size', sizeStr);

		// return false;
		try {

			toast.promise(
				api
					.uploadSalesInvoiceAttachment(id, formData)
					.then(
						(res) => {
							if (res.status) {
								// setInProgressFileUploadCollection((oldData) =>
								// 	oldData.filter((item) => item.filename !== attachment.name)
								// );
								setRemoveFilenameFromInProgressFileUploadCollection(attachmentName);
								setRefreshKey(oldKey => oldKey + 1);
							} else {
								toast.error(`Uploading attachment failed. Please try again.`);
							}

							return res?.status ? res : null;
						},
						() => {}
					),
				{
					loading: 'uploading file...',
					success: (data) => `${data.message}`,
					error: <b>Failed to upload file</b>
				}
			);
			
		} catch (error) {
			toast.error('Error uploading file');
		}
	};


	const isMobile = useIsMobile();
	const [showChangeStatusModal, setShowChangeStatusModal] = useState(false);

	const [collapsedAttachments, setCollapsedAttachments] = useState({});

	const toggleAttachmentCollapse = (index) => {
		setCollapsedAttachments((prev) => ({
			...prev,
			[index]: !prev[index]
		}));
	};	
	
	return (
		<div className="row m-0 w-100 est-nv-container">
			<div className="col-12 col-md-8 col-lg-8 col-xl-9 p-0 p-md-2 inv-preview">
				<div className="show-on-mobile new-page-header" style={{ position: 'relative' }}>
					<div className="header-bubble" />
					<div className="d-flex flex-column gap-2 " style={{ position: 'relative', zIndex: 1, paddingTop: 10, width: '100%' }}>
						<div
							style={{
								position: 'relative',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								marginBottom: 8,
								minHeight: 38 // ensures enough height for the button
							}}
						>
							{' '}
							<button
								type="button"
								aria-label="Back"
								onClick={() => history(-1)}
								className="circle-back-btn"
								style={{
									position: 'absolute',
									left: 20,
									top: '50%',
									transform: 'translateY(-50%)'
								}}
							>
								{/* Replace with your fi arrow icon, example below */}
								<svg width="22" height="22" fill="none" viewBox="0 0 24 24">
									<path d="M15 19l-7-7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
								</svg>
							</button>
							<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
								<h5 style={{ textAlign: 'center', flex: 1, margin: 0, whiteSpace: 'nowrap' }}>{selectedEstimate?.invoice_number}</h5>
								<StatusBadge itemStatus={selectedEstimate?.master_status?.name} />
							</div>
						</div>

						<div
							className={`${
								selectedEstimate?.master_status?.status_type_id !== 2 &&
								!selectedEstimate?.is_credit_note &&
								!statusAllowedToPayAndSalesOrder.includes(selectedEstimate?.master_status?.name)
									? 'horizontal-scroll'
									: 'centered-buttons'
							}`}
							style={{ paddingLeft: 20, paddingRight: 20 }}
						>
							<button
								type="button"
								className="btn btn-primary btn-outlined-main white-var"
								style={{ minWidth: 'unset' }}
								onClick={() => {
									if (selectedEstimate?.master_status?.status_type_id == 2) {
										openSendEmailModal('quotation');
									} else {
										openSendEmailModal(`${selectedEstimate?.master_status?.name == 'Credit Note' ? 'credit-note' : 'invoice'}`);
									}
									setSelectedForSending(selectedEstimate?.id);
								}}
								disabled={!estimateRow?.estimate_number}
							>
								<svg
									id="fi_2983788"
									enable-background="new 0 0 512.005 512.005"
									height="18"
									viewBox="0 0 512.005 512.005"
									width="18"
									xmlns="http://www.w3.org/2000/svg"
								>
									<g>
										<path
											d="m511.658 51.675c2.496-11.619-8.895-21.416-20.007-17.176l-482 184c-5.801 2.215-9.638 7.775-9.65 13.984-.012 6.21 3.803 11.785 9.596 14.022l135.403 52.295v164.713c0 6.948 4.771 12.986 11.531 14.593 6.715 1.597 13.717-1.598 16.865-7.843l56.001-111.128 136.664 101.423c8.313 6.17 20.262 2.246 23.287-7.669 127.599-418.357 122.083-400.163 122.31-401.214zm-118.981 52.718-234.803 167.219-101.028-39.018zm-217.677 191.852 204.668-145.757c-176.114 185.79-166.916 176.011-167.684 177.045-1.141 1.535 1.985-4.448-36.984 72.882zm191.858 127.546-120.296-89.276 217.511-229.462z"
											fill="currentColor"
										></path>
									</g>
								</svg>
								Send
							</button>
							<button
								type="button"
								className="btn btn-primary btn-outlined-main white-var"
								style={{ minWidth: 'unset' }}
								disabled={!estimateRow?.estimate_number}
								onClick={() => {
									if (selectedEstimate?.master_status?.status_type_id == 2) {
										downloadEstimate('estimate', 'customer');
									} else {
										if (selectedEstimate?.transit_company?.name) {
											downloadEstimate('invoice', 'transitcompany');
										} else {
											downloadEstimate('invoice', 'customer');
										}
									}
								}}
							>
								<svg
									id="fi_2767144"
									enable-background="new 0 0 128 128"
									height="18"
									viewBox="0 0 128 128"
									width="18"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										id="Download"
										d="m128 65c0 15.439-12.563 28-28 28h-20c-2.211 0-4-1.791-4-4s1.789-4 4-4h20c11.027 0 20-8.973 20-20s-8.973-20-20-20h-4c-2.211 0-4-1.791-4-4 0-15.439-12.563-28-28-28s-28 12.561-28 28c0 2.209-1.789 4-4 4h-4c-11.027 0-20 8.973-20 20s8.973 20 20 20h20c2.211 0 4 1.791 4 4s-1.789 4-4 4h-20c-15.437 0-28-12.561-28-28s12.563-28 28-28h.223c1.996-17.975 17.277-32 35.777-32s33.781 14.025 35.777 32h.223c15.438 0 28 12.561 28 28zm-50.828 37.172-9.172 9.172v-50.344c0-2.209-1.789-4-4-4s-4 1.791-4 4v50.344l-9.172-9.172c-1.563-1.563-4.094-1.563-5.656 0s-1.563 4.094 0 5.656l16 16c.781.781 1.805 1.172 2.828 1.172s2.047-.391 2.828-1.172l16-16c1.563-1.563 1.563-4.094 0-5.656s-4.094-1.563-5.656 0z"
										fill="currentColor"
									></path>
								</svg>
								Download
							</button>
							<button
								type="button"
								className="btn btn-primary btn-outlined-main white-var"
								style={{ minWidth: 'unset', display: 'none' }}
								disabled={!estimateRow?.estimate_number}
								onClick={() => {
									if (selectedEstimate?.master_status?.status_type_id == 2) {
										downloadEstimate('custom_estimate', 'customer');
									} else {
										downloadEstimate('custom_invoice', 'customer');
									}
								}}
							>
								<svg
									id="fi_2767144"
									enable-background="new 0 0 128 128"
									height="18"
									viewBox="0 0 128 128"
									width="18"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										id="Download"
										d="m128 65c0 15.439-12.563 28-28 28h-20c-2.211 0-4-1.791-4-4s1.789-4 4-4h20c11.027 0 20-8.973 20-20s-8.973-20-20-20h-4c-2.211 0-4-1.791-4-4 0-15.439-12.563-28-28-28s-28 12.561-28 28c0 2.209-1.789 4-4 4h-4c-11.027 0-20 8.973-20 20s8.973 20 20 20h20c2.211 0 4 1.791 4 4s-1.789 4-4 4h-20c-15.437 0-28-12.561-28-28s12.563-28 28-28h.223c1.996-17.975 17.277-32 35.777-32s33.781 14.025 35.777 32h.223c15.438 0 28 12.561 28 28zm-50.828 37.172-9.172 9.172v-50.344c0-2.209-1.789-4-4-4s-4 1.791-4 4v50.344l-9.172-9.172c-1.563-1.563-4.094-1.563-5.656 0s-1.563 4.094 0 5.656l16 16c.781.781 1.805 1.172 2.828 1.172s2.047-.391 2.828-1.172l16-16c1.563-1.563 1.563-4.094 0-5.656s-4.094-1.563-5.656 0z"
										fill="currentColor"
									></path>
								</svg>
								{selectedEstimate?.master_status?.status_type_id == 2 ? 'Download custom estimate to customer' : 'Download custom invoice to customer'}
								
							</button>
							{selectedEstimate?.master_status?.status_type_id !== 2 &&
								!statusAllowedToPayAndSalesOrder.includes(selectedEstimate?.master_status?.name) && (
									<>
										{selectedEstimate?.master_status?.name != 'Paid' && (
											<PermissionAllowed permissions={['Add Payment Transaction']}>
												<button
													type="button"
													className="btn btn-primary btn-outlined-main white-var m-0"
													style={{ minWidth: 'unset', margin: '0 !important' }}
													onClick={() => {
														setShowAddPaymentModal(true);
													}}
													disabled={!selectedEstimate?.estimation_number}
												>
													<RegisterPaymentIcon height="20px" width="20px" />
													Payment
												</button>
											</PermissionAllowed>
										)}
									</>
								)}
							<PermissionAllowed permissions={['Delete Estimation (Button)']}>
								{statusAllowedToDeleteDraft.includes(selectedEstimate?.master_status?.name) && (
									((selectedEstimate?.master_status?.name == 'Draft' && selectedEstimate?.master_status?.status_type_id == 2) ||
										(selectedEstimate?.master_status?.name == 'Draft' &&
											selectedEstimate?.master_status?.status_type_id == 3 &&
											!selectedEstimate?.qoutation_id)) && (
										<button
											type="button"
											className="btn btn-primary btn-outlined-danger white-var"
											style={{ minWidth: 'unset' }}
											disabled={!estimateRow?.estimate_number}
											onClick={() => {
												deleteEstimate(selectedEstimate);
											}}
										>
											<FaRegTrashCan />
											Delete Draft
										</button>
									)
								)}
							</PermissionAllowed>
							{selectedEstimate?.master_status?.name && (
								(statusAllowedToAccept.includes(selectedEstimate?.master_status?.name) ||
									statusAllowedToCancel.includes(selectedEstimate?.master_status?.name)) && (
									<button
										type="button"
										className="btn btn-primary btn-outlined-main white-var"
										style={{ minWidth: 'unset' }}
										disabled={!estimateRow?.estimate_number}
										onClick={() => {
											setShowChangeStatusModal(true);
										}}
									>
										Change Status
									</button>
								)
							)}
						</div>
					</div>
				</div>
				<div className="section-head-new pl-0 mb-1 mt-2 hide-on-mobile">
					<div className="actions" style={{ gap: '5px', width: 'auto' }}>
						{showActions && (
							<>
								{!selectedEstimate ? (
									<div style={{ width: '90px' }}>
										<Skeleton variant="rounded" width={'100%'} height={26}></Skeleton>
									</div>
								) : (
									<button
										type="button"
										className="btn btn-primary btn-outlined-main white-var"
										style={{ minWidth: 'unset' }}
										onClick={() => {
											if (selectedEstimate?.master_status?.status_type_id == 2) {
												openSendEmailModal('quotation');
											} else {
												openSendEmailModal(`${selectedEstimate?.master_status?.name == 'Credit Note' ? 'credit-note' : 'invoice'}`);
											}
											setSelectedForSending(selectedEstimate?.id);
										}}
										disabled={!estimateRow?.estimate_number}
									>
										<svg
											id="fi_2983788"
											enable-background="new 0 0 512.005 512.005"
											height="18"
											viewBox="0 0 512.005 512.005"
											width="18"
											xmlns="http://www.w3.org/2000/svg"
										>
											<g>
												<path
													d="m511.658 51.675c2.496-11.619-8.895-21.416-20.007-17.176l-482 184c-5.801 2.215-9.638 7.775-9.65 13.984-.012 6.21 3.803 11.785 9.596 14.022l135.403 52.295v164.713c0 6.948 4.771 12.986 11.531 14.593 6.715 1.597 13.717-1.598 16.865-7.843l56.001-111.128 136.664 101.423c8.313 6.17 20.262 2.246 23.287-7.669 127.599-418.357 122.083-400.163 122.31-401.214zm-118.981 52.718-234.803 167.219-101.028-39.018zm-217.677 191.852 204.668-145.757c-176.114 185.79-166.916 176.011-167.684 177.045-1.141 1.535 1.985-4.448-36.984 72.882zm191.858 127.546-120.296-89.276 217.511-229.462z"
													fill="currentColor"
												></path>
											</g>
										</svg>
										Send
									</button>
								)}

								{!selectedEstimate ? (
									<div style={{ width: '90px' }}>
										<Skeleton variant="rounded" width={'100%'} height={26}></Skeleton>
									</div>
								) : (
									<>
										<button
											type="button"
											className="btn btn-primary btn-outlined-main white-var"
											style={{ minWidth: 'unset' }}
											disabled={!estimateRow?.estimate_number}
											onClick={() => {
												if (selectedEstimate?.master_status?.status_type_id == 2) {
													downloadEstimate('estimate', 'customer');
												} else {
													if (selectedEstimate?.transit_company?.name) {
														downloadEstimate('invoice', 'transitcompany');
													} else {
														downloadEstimate('invoice', 'customer');
													}
												}
											}}
										>
											<svg
												id="fi_2767144"
												enable-background="new 0 0 128 128"
												height="18"
												viewBox="0 0 128 128"
												width="18"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													id="Download"
													d="m128 65c0 15.439-12.563 28-28 28h-20c-2.211 0-4-1.791-4-4s1.789-4 4-4h20c11.027 0 20-8.973 20-20s-8.973-20-20-20h-4c-2.211 0-4-1.791-4-4 0-15.439-12.563-28-28-28s-28 12.561-28 28c0 2.209-1.789 4-4 4h-4c-11.027 0-20 8.973-20 20s8.973 20 20 20h20c2.211 0 4 1.791 4 4s-1.789 4-4 4h-20c-15.437 0-28-12.561-28-28s12.563-28 28-28h.223c1.996-17.975 17.277-32 35.777-32s33.781 14.025 35.777 32h.223c15.438 0 28 12.561 28 28zm-50.828 37.172-9.172 9.172v-50.344c0-2.209-1.789-4-4-4s-4 1.791-4 4v50.344l-9.172-9.172c-1.563-1.563-4.094-1.563-5.656 0s-1.563 4.094 0 5.656l16 16c.781.781 1.805 1.172 2.828 1.172s2.047-.391 2.828-1.172l16-16c1.563-1.563 1.563-4.094 0-5.656s-4.094-1.563-5.656 0z"
													fill="currentColor"
												></path>
											</svg>
											Download
										</button>

										<button
											type="button"
											className="btn btn-primary btn-outlined-main white-var"
											style={{ minWidth: 'unset', display: 'none' }}
											disabled={!estimateRow?.estimate_number}
											onClick={() => {
												if (selectedEstimate?.master_status?.status_type_id == 2) {
													downloadEstimate('custom_estimate', 'customer');
												} else {
													downloadEstimate('custom_invoice', 'customer');
												}
											}}
										>
											<svg
												id="fi_2767144"
												enable-background="new 0 0 128 128"
												height="18"
												viewBox="0 0 128 128"
												width="18"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													id="Download"
													d="m128 65c0 15.439-12.563 28-28 28h-20c-2.211 0-4-1.791-4-4s1.789-4 4-4h20c11.027 0 20-8.973 20-20s-8.973-20-20-20h-4c-2.211 0-4-1.791-4-4 0-15.439-12.563-28-28-28s-28 12.561-28 28c0 2.209-1.789 4-4 4h-4c-11.027 0-20 8.973-20 20s8.973 20 20 20h20c2.211 0 4 1.791 4 4s-1.789 4-4 4h-20c-15.437 0-28-12.561-28-28s12.563-28 28-28h.223c1.996-17.975 17.277-32 35.777-32s33.781 14.025 35.777 32h.223c15.438 0 28 12.561 28 28zm-50.828 37.172-9.172 9.172v-50.344c0-2.209-1.789-4-4-4s-4 1.791-4 4v50.344l-9.172-9.172c-1.563-1.563-4.094-1.563-5.656 0s-1.563 4.094 0 5.656l16 16c.781.781 1.805 1.172 2.828 1.172s2.047-.391 2.828-1.172l16-16c1.563-1.563 1.563-4.094 0-5.656s-4.094-1.563-5.656 0z"
													fill="currentColor"
												></path>
											</svg>
											{selectedEstimate?.master_status?.status_type_id == 2 ? 'Download custom estimate to customer' : 'Download custom invoice to customer'}
										</button>
									</>
								)}

								{!selectedEstimate ? (
									<div style={{ width: '90px' }}>
										<Skeleton variant="rounded" width={'100%'} height={26}></Skeleton>
									</div>
								) : (
									selectedEstimate?.master_status?.status_type_id !== 2 &&
										!statusAllowedToPayAndSalesOrder.includes(selectedEstimate?.master_status?.name) && (
											selectedEstimate?.master_status?.name != 'Paid' && (
												<PermissionAllowed permissions={['Add Payment Transaction']}>
													<button
														type="button"
														className="btn btn-primary btn-outlined-main white-var m-0"
														style={{ minWidth: 'unset', margin: '0 !important' }}
														onClick={() => {
															setShowAddPaymentModal(true);
														}}
														disabled={!selectedEstimate?.estimation_number}
													>
														<RegisterPaymentIcon height="20px" width="20px" />
														Payment
													</button>
												</PermissionAllowed>
											)
										)
								)}

							</>
						)}
					</div>
					<div className="actions" style={{ gap: '5px' }}>
						

						<div className="est-detail-item">
							{!selectedEstimate ? (
								<div style={{ width: '120px' }}>
									<Skeleton variant="rounded" width={'100%'} height={26}></Skeleton>
								</div>
							) : (
								selectedEstimate?.master_status?.name == 'Credit Note' ? (
									selectedEstimate?.paid_status == 'Paid' ? (
										<StatusBadge itemStatus="Paid" />
									) : (
										<StatusBadge itemStatus={selectedEstimate?.is_draft == 1 ? 'Draft' : selectedEstimate?.master_status?.name} />
									)
								) : (
									<StatusBadge itemStatus={selectedEstimate?.is_draft == 1 ? 'Draft' : selectedEstimate?.master_status?.name} />
								)
							)}
						</div>
						{!selectedEstimate ? (
							<div style={{ width: '120px' }}>
								<Skeleton variant="rounded" width={'100%'} height={26}></Skeleton>
							</div>
						) : (
							<PermissionAllowed permissions={['Edit Estimation (Button)']}>
								<Dropdown
									className="btnDel est-btn iconbtn"
									align={'end'}
									onToggle={(isOpen) => setIsExtraDropdownOpen(isOpen)}
								>
									<Dropdown.Toggle as="span">
										<Link to={''} className="btn btn-primary btn-outlined-main white-var" style={{ minWidth: 'unset' }}>
											Extra {isExtraDropdownOpen ? <LuChevronUp /> : <LuChevronDown />}
										</Link>
									</Dropdown.Toggle>
									<Dropdown.Menu>
										{statusAllowedToAccept.includes(selectedEstimate?.master_status?.name) && (
											<PermissionAllowed permissions={['Accept Estimation (Button)']}>
												<Dropdown.Item onClick={() => acceptOrder(selectedEstimate)}>Accept</Dropdown.Item>
											</PermissionAllowed>
										)}
										{statusAllowedToAccept.includes(selectedEstimate?.master_status?.name) && (
											<PermissionAllowed permissions={['Create New Estimation (Action)']}>
												<Dropdown.Item
													onClick={() => {
														billOrder(selectedEstimate);
													}}
												>
													Billed
												</Dropdown.Item>
											</PermissionAllowed>
										)}
										{
											!selectedEstimate?.sales_order_id && (
												selectedEstimate?.master_status?.status_type_id !== 2 &&
													!selectedEstimate?.is_credit_note &&
													!statusAllowedToPayAndSalesOrder.includes(selectedEstimate?.master_status?.name) && (
													<PermissionAllowed permissions={['Create Sales Order']}>
														<Dropdown.Item
															onClick={() => {
																createSalesOrder(selectedEstimate)
															}}
														>
															Create Sales Order
															
														</Dropdown.Item>
													</PermissionAllowed>
												)
											)
										}
										{statusAllowedToCancel.includes(selectedEstimate?.master_status?.name) && (
											<PermissionAllowed permissions={['Cancel Estimation (Button)']}>
												<Dropdown.Item
													onClick={() => {
														setShowCancelPopup(true);
													}}
												>
													Cancel
												</Dropdown.Item>
											</PermissionAllowed>
										)}
											
										{
											salesType !== 'estimate' && (
												<>
													{
														selectedEstimate?.is_credit_note === 1 ? (
															<>
																<Dropdown.Item
																	onClick={() => {
																		duplicateCreditNoteAsCreditNote(selectedEstimate?.id)
																	}}
																>
																	Duplicate Credit Note
																</Dropdown.Item>
																<Dropdown.Item
																	onClick={() => {
																		duplicateCreditNoteAsInvoice(selectedEstimate?.id)
																		// billOrder(selectedEstimate);
																	}}
																>
																	Duplicate to Invoice
																</Dropdown.Item>
															</>
														) : (
															<>
																<Dropdown.Item
																	onClick={() => {
																		duplicateInvoiceAsInvoice(selectedEstimate?.id)
																	}}
																>
																	Duplicate Invoice
																</Dropdown.Item>
																<Dropdown.Item
																	onClick={() => {
																		duplicateInvoiceAsCreditNote(selectedEstimate?.id)
																		// billOrder(selectedEstimate);
																	}}
																>
																	Duplicate to Credit Note
																</Dropdown.Item>
															</>
														)
													}
													{selectedEstimate?.master_status?.status_type_id !== 2 && (
														<PermissionAllowed permissions={['Create Sales Order']}>
															<Dropdown.Item
																onClick={() => {
																	duplicateInvoiceAsSalesOrder(selectedEstimate?.id)
																}}
															>
																Duplicate to Sales Order
															</Dropdown.Item>
														</PermissionAllowed>
													)}
												</>
											)
										}
										{statusAllowedToComplete.includes(selectedEstimate?.master_status?.name) && (
											<Dropdown.Item
												onClick={() => {
													setShowCompletePopup(true)
												}}
											>
												{ selectedEstimate?.master_status?.name === 'Paid' ? 'Complete' : 'Re-open' }
											</Dropdown.Item>
										)}
											
										{
											selectedEstimate?.is_credit_note === 1 && selectedEstimate?.master_status?.name === 'Credit Note' && (
												<Dropdown.Item
													onClick={() => {
														setShowCompletePopup(true)
													}}
												>
													{ selectedEstimate?.master_status?.name === 'Credit Note' ? 'Complete' : 'Re-open' }
												</Dropdown.Item>
											)
										}
																
										{selectedEstimate && (
											<>
												<PermissionAllowed permissions={['Delete Estimation (Button)']}>
													{statusAllowedToDeleteDraft.includes(selectedEstimate?.master_status?.name) && (
														((selectedEstimate?.master_status?.name == 'Draft' && selectedEstimate?.master_status?.status_type_id == 2) ||
															(selectedEstimate?.master_status?.name == 'Draft' &&
																selectedEstimate?.master_status?.status_type_id == 3 &&
																!selectedEstimate?.qoutation_id)) && (
																<Dropdown.Item
																	onClick={() => {
																		deleteEstimate(selectedEstimate);
																	}}
																>
																	Delete Draft
																</Dropdown.Item>
														)
													)}
												</PermissionAllowed>
												{
													(selectedEstimate?.master_status?.name === 'Credit Note' && selectedEstimate?.is_draft === 1) && (
														<PermissionAllowed permissions={['Delete Estimation (Button)']}>
															<Dropdown.Item
																onClick={() => {
																	deleteEstimate(selectedEstimate);
																}}
															>
																Delete Draft
															</Dropdown.Item>
														</PermissionAllowed>
													)
												}
												{
													(selectedEstimate?.master_status?.name === 'Credit Note') ? (
														selectedEstimate?.is_allowed_to_delete === true && (
															<PermissionAllowed permissions={['Delete Estimation (Button)']}>
																<Dropdown.Item
																	onClick={() => {
																		setShowDeleteCreditNotePopup(true);
																	}}
																>
																	Delete 
																</Dropdown.Item>
															</PermissionAllowed>
														)
													) : (
														selectedEstimate?.is_allowed_to_delete && (
															<PermissionAllowed permissions={['Delete Estimation (Button)']}>
																<Dropdown.Item
																	onClick={() => {
																		if (salesType === 'invoice') {
																			setShowDeleteInvoicePopup(true);
																		} else {
																			setShowDeleteQuotationPopup(true);
																		}
																	}}
																>
																	Delete 
																</Dropdown.Item>
															</PermissionAllowed>
														)
													)
												}
											</>
										)}
										{
											defaultPageTitle === 'Invoice' && (
												<Dropdown.Item onClick={exportDataToCsv} >
													Export to CSV
												</Dropdown.Item>
											)
										}
									</Dropdown.Menu>
								</Dropdown>
							</PermissionAllowed>
						)}
					</div>
				</div>
				<div className="row hide-on-mobile">
					<div className="col-12">
						{!selectedEstimate ? (
							<div style={{ marginTop: '-7px', marginBottom: '10.2px' }}>
								<Skeleton variant="rounded" width={'100%'} height={160} style={{ borderRadius: '12px' }} />
							</div>
						) : (
							selectedEstimate?.is_credit_note !== 1 && (
								salesType === 'invoice' && selectedEstimate?.master_status?.name !== 'Draft' && (
									<div>
										<Timeline
											refreshKey={refreshTimelineKey}
											id={id}
											source={'invoice'}
											pendingQty={selectedEstimate?.pending_qty}
											productOverviewCount={totalProductOverviewItems}
										/>
									</div>
								)
							)
						)}
					</div>
				</div>
				<div className="row m-0 mobile-scroll-container">
					<div className="show-on-mobile" style={{ width: '100%', display: 'flex' }}>
						{!selectedEstimate ? (
							<div style={{ width: '100%', marginBottom: '8px' }}>
								<Skeleton variant="rounded" width={'100%'} height={34} style={{ borderRadius: '12px' }}></Skeleton>
							</div>
						) : (
							selectedEstimate?.is_credit_note !== 1 && (
								salesType === 'invoice' && selectedEstimate?.master_status?.name !== 'Draft' && (
									<div style={{ width: '100%', marginBottom: '8px', paddingTop: 10 }}>
										<Timeline 
											refreshKey={refreshTimelineKey}
											id={id}
											source={'invoice'}
											pendingQty={selectedEstimate?.pending_qty}
											productOverviewCount={totalProductOverviewItems}
										/>
									</div>
								)
							)
						)}
					</div>
					<div className="mb-3 p-3 p-xl-4 w-100 new-card">
						<EstimateDetailInvoice estimate={selectedEstimate} modulePath={salesTypePath} />
						{!isMobile && (
							<>
								{salesType === 'estimate' && selectedEstimate?.invoice?.id && <InvoiceComponent details={selectedEstimate} />}
								{salesType === 'invoice' && selectedEstimate?.qoutation?.id && <QoutationComponent details={selectedEstimate} />}
								{selectedEstimate?.sales_order?.id && <SalesOrderComponent details={selectedEstimate} />}
								
								{selectedEstimate?.is_credit_note === 1 && selectedEstimate?.credit_payments?.length > 0 && (
									<CreditPaymentComponent details={selectedEstimate} onHandleReloadCreditNote={handleReloadCreditNote} />
								)}
								{selectedEstimate?.payments?.length > 0 && (
									<div style={{ padding: '0px 20px 20px 16px' }}>
										<div className="row mb10">
											<div className="col-12">
												<h2 className="d-flex font600" style={{ fontSize: '18px' }}>
													Payments
												</h2>
											</div>
										</div>

										<div className="row">
											<div className="col-md-3 font600">Date</div>
											<div className="col-md-3 font600">Type</div>
											<div className="col-md-3 font600">Amount</div>
											<div className="col-md-3 font600">Processed By</div>
										</div>
										<hr className="mt8 mb8" />
										{selectedEstimate?.payments?.map((payment, index) => (
											<>
												<div className="row hover-row" key={index}>
													<div className="col-md-3">{moment(payment?.payment_date).format(CommonDateOnlyFormat)}</div>
													<div className="col-md-3">
														{payment?.pay_type == 'credit-note' ? (
															payment?.credit_note?.credit_note_number ? (
																<div
																	className={`${
																		hasEveryPermission(['View Estimation Details (Page)']) ? 'text-primary cursor-pointer' : ''
																	}`}
																	onClick={() => {
																		if (hasEveryPermission(['View Estimation Details (Page)'])) {
																			handleOpenNewTab('invoices', payment?.credit_note?.id);
																		}
																	}}
																>
																	Credit Note {payment?.credit_note?.credit_note_number}
																</div>
															) : (
																'Credit Note'
															)
														) : payment?.pay_type == 'bank-charges' ? (
															'Bank Charges'
														) : payment?.pay_type == 'credit_card' ? (
															'Credit Card'
														) : payment?.pay_type == 'bank_cheque' ? (
															'Bank Cheque'
														) : payment?.pay_type == 'cash' ? (
															'Cash'
														) : payment?.pay_type == 'usdt' ? (
															'USDT'
														) : (
															'Wired'
														)}
													</div>
													<div className="col-md-3  text-success">
														{payment?.payment_amount && payment?.payment_currency ? (
															<>
																{getCurrencySymbol(payment?.payment_currency)}
																{
																	selectedEstimate?.is_credit_note === 1 ? (
																		numberFormatter.format(Math.abs(payment?.payment_amount))
																	) : (
																		numberFormatter.format(payment?.payment_amount)		
																	)
																}
															</>
														) : (
															<>
																{getCurrencySymbol(payment?.currency)}
																{
																	selectedEstimate?.is_credit_note === 1 ? (
																		numberFormatter.format(Math.abs(payment?.amount_paid))
																	) : (
																		numberFormatter.format(payment?.amount_paid)		
																	)
																}
															</>
														)}
													</div>
													<div className="col-md-3">{payment?.user_created?.first_name}</div>
													<div className="hover-button-container-lg mr-20 mt0">
														<div>
															<div className="hover-button">
																{payment?.attachment && (
																	<div
																		className="btn btn-primary btn-outlined-main white-var btn-sm cursor-pointer"
																		style={{ marginLeft: '8px' }}
																		onClick={() => {
																			window.open(payment.attachment, '_blank');
																		}}
																	>
																		<div style={{ margin: 'auto 5px auto 3px' }}>
																			<FaPaperclip />
																		</div>
																	</div>
																)}
																<PermissionAllowed permissions={['Delete Payment Transaction']}>
																	<div
																		className="btn btn-danger white-var btn-sm cursor-pointer"
																		style={{ marginLeft: '8px' }}
																		onClick={() => {
																			deletePayment(payment?.id);
																		}}
																	>
																		<div style={{ margin: 'auto 3px' }}>
																			<DeleteIcon height="14px" width="14px" />
																		</div>
																	</div>
																</PermissionAllowed>
															</div>
														</div>
													</div>
												</div>
												<hr className="mt8 mb8" />
											</>
										))}
									</div>
								)}
								{selectedEstimate?.purchase_order?.length > 0 && <PurchaseOrderComponent details={selectedEstimate?.purchase_order} />}
								{selectedEstimate?.shipments?.length > 0 && <ShipmentsComponent details={selectedEstimate} />}
								{showAcceptPopup && (
									<AcceptOrderModal
										show={showAcceptPopup}
										handleClose={() => setShowAcceptPopup(null)}
										handleConfirm={handleAcceptConfirm}
									/>
								)}
							</>
						)}
					</div>
					{isMobile && (
						<>
							{salesType === 'estimate' && selectedEstimate?.invoice?.id && (
								<div className="mb-3 p-3 p-xl-4 w-100 new-card">
									<InvoiceComponent details={selectedEstimate} />
								</div>
							)}
							{salesType === 'invoice' && selectedEstimate?.qoutation?.id && (
								<div className="mb-3 p-3 p-xl-4 w-100 new-card">
									<QoutationComponent details={selectedEstimate} />
								</div>
							)}
							{selectedEstimate?.sales_order?.id && (
								<div className="mb-3 p-3 p-xl-4 w-100 new-card">
									<SalesOrderComponent details={selectedEstimate} />
								</div>
							)}
							{selectedEstimate?.is_credit_note === 1 && selectedEstimate?.credit_payments?.length > 0 && (
								<div className="mb-3 p-3 p-xl-4 w-100 new-card">
									<CreditPaymentComponent details={selectedEstimate} onHandleReloadCreditNote={handleReloadCreditNote} />
								</div>
							)}
							{selectedEstimate?.payments?.length > 0 && (
								<div className="mb-3 p-3 p-xl-4 w-100 new-card">
									<h2
										className="font600"
										style={{
											fontSize: '18px',
											borderBottom: '1px solid #e0e0e0',
											paddingBottom: '10px',
											marginBottom: 0
										}}
									>
										Payments
									</h2>
									{selectedEstimate?.payments?.map((payment, index) => (
										<div
											key={payment?.id || index}
											style={{
												display: 'flex',
												width: '100%',
												justifyContent: 'space-between',
												alignItems: 'center',
												borderBottom: '1px solid #eee',
												paddingTop: 5,
												paddingBottom: 5
											}}
										>
											<div style={{ display: 'flex', flexDirection: 'column' }}>
												<div style={{ fontWeight: 500 }}>
													{payment?.pay_type == 'credit-note'
														? 'Credit Note'
														: payment?.pay_type == 'bank-charges'
														? 'Bank Charges'
														: payment?.pay_type == 'credit_card'
														? 'Credit Card'
														: payment?.pay_type == 'bank_cheque'
														? 'Bank Cheque'
														: payment?.pay_type == 'cash'
														? 'Cash'
														: 'Wired'}
												</div>
												<div style={{ fontWeight: 400 }}>{moment(payment?.payment_date).format(CommonDateOnlyFormat)}</div>
											</div>
											<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
												<div style={{ fontWeight: 500 }}>
													{getCurrencySymbol(payment?.currency)} {numberFormatter.format(payment?.amount_paid)}
												</div>
											</div>
										</div>
									))}
								</div>
							)}
							{selectedEstimate?.purchase_order?.length > 0 && (
								<div className="mb-3 p-3 p-xl-4 w-100 new-card">
									<PurchaseOrderComponent details={selectedEstimate?.purchase_order} />
								</div>
							)}
							{selectedEstimate?.shipments?.length > 0 && (
								<div className="mb-3 p-3 p-xl-4 w-100 new-card">
									<ShipmentsComponent details={selectedEstimate} />
								</div>
							)}
						</>
					)}
					
					{salesType != 'credit-note' && (
						orderAgreementsData?.length > 0 && (
							<div className="card shadow-sm rounded bg-white mb-3 p-3 p-xl-4 w-100">
								<div className="row">
									<div className="col-12">
										<div className="row">
											<div className="col-12">
												<div className="text-center mb-3 pt-2">
													<img src={agreementImage} alt="" height="70px" className="agreement-img" />
												</div>
											</div>
										</div>
										<div className="row">
											<div className="col-12">
												<h4 className="text-center mb-3">SALES AGREEMENT</h4>
											</div>
										</div>
										<div className="row">
											<div className="col-md-10 offset-md-1">
												<p className="text-center mb-3">
													This agreement is made on <Link to="#">{moment(selectedEstimate?.invoiceDate).format('DD MMMM YYYY')}</Link>{' '}
													between{' '}
													<Link to={`/contacts/${selectedEstimate?.customer?.id}`} target="_blank">
														<PrivacyModeContent>{selectedEstimate?.customer?.name}</PrivacyModeContent>
													</Link>
													,{' '}
													{selectedEstimate?.customer?.address && (
														<>
															located at{' '}
															<Link to="#">
																<PrivacyModeContent>
																	{selectedEstimate?.customer?.address ? `${selectedEstimate?.customer?.address}, ` : ''}
																	{selectedEstimate?.customer?.zipcode ? `${selectedEstimate?.customer?.zipcode}, ` : ''}
																	{selectedEstimate?.customer?.city ? `${selectedEstimate?.customer?.city}, ` : ''}
																	{selectedEstimate?.customer?.country ? `${selectedEstimate?.customer?.country}` : ''}
																</PrivacyModeContent>
															</Link>{' '}
															(The Client){' '}
														</>
													)}
													and{' '}
													{selectedEstimate?.transit_company?.name && (
														<>
															<Link to={`/contacts/${selectedEstimate?.transit_company?.id}`} target="_blank">
																{selectedEstimate?.transit_company?.name}
															</Link>{' '}
															{selectedEstimate?.transit_company?.address && (
																<>
																	located at{' '}
																	<Link to="#">
																		{selectedEstimate?.transit_company?.address
																			? `${selectedEstimate?.transit_company?.address}, `
																			: ''}
																		{selectedEstimate?.transit_company?.zipcode
																			? `${selectedEstimate?.transit_company?.zipcode}, `
																			: ''}
																		{selectedEstimate?.transit_company?.city ? `${selectedEstimate?.transit_company?.city}, ` : ''}
																		{selectedEstimate?.transit_company?.country
																			? `${selectedEstimate?.transit_company?.country}`
																			: ''}
																	</Link>{' '}
																</>
															)}
															(The Supplier).
														</>
													)}
												</p>
											</div>
										</div>

										<div className="row">
											<div className="col-md-10 offset-md-1">
												<p className="text-center mb-3">
													Both parties confirm that they have mutually agreed upon the following conditions, as negotiated between{' '}
													<b>
														{selectedEstimate?.sales_person?.first_name} {selectedEstimate?.sales_person?.last_name}
													</b>
													, {selectedEstimate?.transit_company?.name && <> representing {selectedEstimate?.transit_company?.name}</>},{' '}
													and{' '}
													{selectedEstimate?.customer?.contact_name ? (
														<>
															<Link to={`contact/${selectedEstimate?.customer?.id}`} target="_blank">
																<PrivacyModeContent>{selectedEstimate?.customer?.name}</PrivacyModeContent>
															</Link>
															, the representative of{' '}
														</>
													) : (
														''
													)}{' '}
													the representative of{' '}
													<Link to={`/contacts/${selectedEstimate?.customer?.id}`} target="_blank">
														<PrivacyModeContent>{selectedEstimate?.customer?.name}</PrivacyModeContent>
													</Link>
													.
												</p>
											</div>
										</div>

										<div className="order-agreements-detail-section">
											{selectedEstimate?.order_agreements?.length > 0 && (
												<>
													{selectedEstimate?.order_agreements?.map((ag) => (
														<div className="order-agreements-detail">
															<h6>{ag?.title}</h6>
															{ag?.type == 'multiselect' ? (
																ag?.responses?.map((res) => <p>{res?.option?.option}</p>)
															) : (
																<p>{ag?.response?.label}</p>
															)}
														</div>
													))}
													<div className="row">
														<div className="col-12">
															<p
																className="d-flex justify-content-center align-items-center text-center mb-4 pt-4"
																style={{ gap: '10px', color: '#838383', fontStyle: 'italic' }}
															>
																Note: <br />
																Please be aware that a 2% charge will be applied to the entire order amount if payment is not made on
																time,
																<br />
																due to fluctuations in USD and EUR currency values.
															</p>
														</div>
													</div>
												</>
											)}
										</div>
									</div>
								</div>
							</div>
						)
					)}
					{selectedPaymentShipment === 'payment' && (
						<PaymentsComponent
							paymentData={paymentData}
							setPaymentData={setPaymentData}
							estimateDetails={selectedEstimate}
							onAddPayment={handleAddPayment}
							onUpdatePayment={handleUpdatePayment}
							onDeletePayment={handleDeletePayment}
							setShowAddPayment={setShowAddPaymentModal}
							showAddPayment={showAddPaymentModal}
							toggleExpand={handlePaymentToggle}
							showOnlyModal={true}
							source={'invoice'}
						/>
					)}
					
					{(selectedEstimate?.master_status?.name !== 'Draft' && salesType !== 'estimate') && (
						<div className="mb-3 w-100">
							{
								!selectedEstimate ? (
									<div>
										<Skeleton variant="rounded" width={'100%'} height={75} style={{ borderRadius: '12px' }} />
									</div>
								) : (
									<>
											

										<div className="row mb-3">
											<div className="col-12">
												<div {...getAttachmentRootProps()}>
													{/* <div className="add-item-empty-div" style={{ alignItems: 'center' }}>
														<button type="button" className="btn btn-primary btn-outlined-main-primary dragText">
															<FaPlus />
															Add File
														</button>
														<span style={{ marginLeft: '10px' }}>or drag file...</span>
													</div> */}
													<div className="add-item-empty-div" style={{ alignItems: 'center' }}>
														<div
															className="text-primary"
															style={{
																marginTop: '1px',
																padding: '5px 7px',
																border: '2px solid #9e9e9e',
																borderRadius: '32px',
															}}
														>
															<PlusIcon height="16px" width="16px" />
														</div>
														<div style={{ marginLeft: '10px' }}>
															<div
																className='flex'
																style={{
																	gap: '5px'
																}}
															>
																<span className="fw-500">Drag & Drop or Click to Upload</span>
																<span className="text-gray-700">OR</span>
																<span className="text-blue-600 fw-500">Browse Files</span>
															</div>
															<div className="text-gray-600 fw-400 mt-1 flex align-items-center" style={{ fontSize: '10px', gap: '5px' }}>
																<InfoIcon width='14px' height='14px' />
																<span>
																	png, jpg, jpeg or pdf (Max file size: 5MB)
																</span>
															</div>
														</div>
													</div>
													<input {...getAttachmentInputProps({ disabled: false })} style={{ display: 'none' }} />{' '}
												</div>
											</div>
										</div>
										
											{/* <div className="row m-0" key={index} style={{ padding: '0' }}> */}
											{
												inProgressFileUploadCollection?.length > 0 && (
													[...inProgressFileUploadCollection].reverse().map((attachment, index) => (
														<div className="row m-0" key={index} style={{ padding: '0' }}>
															<div className="col-12" style={{ padding: '0' }}>
																{/* <div className={`card ${collapsedAttachments[index] ? 'shadow-sm' : '' } bg-white mb-2 w-100 border card-border-gray`}> */}
																<div className={`card bg-white mb-2 w-100 border card-border-gray relative`}>
																	{/* <div className={`${collapsedAttachments[index] ? 'card-header-radius-0' : 'card-header-radius-360'}`} style={{ padding: '0px 10px' }}> */}
																	<div className={`card-header-radius-0`} style={{ padding: '0px 10px' }}>
																		<div className="row">
																			<div className="col-12">
																				<div className="section-head row" style={{ padding: '0px 10px !important', paddingLeft: '8px' }}>
																					<div style={{ alignItems: 'center', fontSize: '14px' }} className="col-md-8 col-6">
																						<div className="flex align-items-center" style={{ gap: '10px' }}>
																							<div>
																								{attachment?.extension === 'application/pdf' ? (
																									<PictureAsPdfOutlinedIcon style={{ fontSize: 24 }} />
																								) : (
																									<InsertPhotoOutlinedIcon style={{ fontSize: 24 }} />
																								)}
																							</div>
																							<div>
																								<div className="">
																									{
																										isMobile ? (
																											'Attachment'
																										) : (
																											attachment?.filename
																										)
																									}
																								</div>
																								<div className="text-gray-600" style={{ fontSize: '12px' }}>{attachment?.size ?? 'Size not mentioned'}</div>

																							</div>
																						</div>
																					</div>
																					<div className="actions col-md-4 col-6 flex align-items-center justify-end" style={{ gap: '8px' }}>
																						<button
																							type="button"
																							// onClick={() => downloadAttachment(attachment)}
																							className="btn btn-primary btn-outlined-main disabled"
																							style={{ minWidth: `${isMobile ? 'auto' : '110px'}` }}
																						>
																							<SettingsDownloadIcon height="16px" width="16px" />
																							Download
																							{/* { !isMobile && 'Download' } */}
																						</button>
																						<button
																							type="button"
																							className="btn btn-danger flex items-center disabled"
																							style={{ gap: '5px' }}
																							// onClick={() => removeAttachment(attachment?.id)}
																						>
																							<DeleteIcon height="14px" width="14px" />
																							{ !isMobile && 'Delete' }
																						</button>
																						<div
																							className={`invoice-attachment-collapse-icon  disabled`}
																							// className={`invoice-attachment-collapse-icon ${collapsedAttachments[index] ? 'collapsed' : ''}`}
																							// onClick={() => toggleAttachmentCollapse(index)}
																						>
																							<LuChevronUp />
																						</div>
																					</div>
																				</div>
																			</div>
																		</div>
																	</div>
																	
																	<div className="card-footer p-0 border-0 bg-transparent" style={{ height: '4px', marginTop: '-4px' }}>
																		<div className="progress" style={{ height: '4px', borderRadius: '0', backgroundColor: 'transparent' }}>
																			<div 
																				className="progress-bar progress-bar-animated" 
																				role="progressbar" 
																				style={{ 
																					width: '100%', 
																					background: 'linear-gradient(90deg, #007bff 0%, #00d4ff 50%, #007bff 100%)',
																					backgroundSize: '200% 100%',
																					animation: 'loading-slide 2s infinite linear'
																				}}
																			></div>
																		</div>
																	</div>


																</div>
															</div>
														</div>
													))
												)
											}


										{selectedEstimate?.attachments?.length > 0 && (
											selectedEstimate.attachments.map((attachment, index) => (
												<div className="row m-0" key={index} style={{ padding: '0' }}>
													<div className="col-12" style={{ padding: '0' }}>
														<div className={`card ${collapsedAttachments[index] ? 'shadow-sm' : '' } bg-white mb-2 w-100 border card-border-gray`}>
															<div className={`${collapsedAttachments[index] ? 'card-header-radius-0' : 'card-header-radius-360'}`} style={{ padding: '0px 10px' }}>
																<div className="row">
																	<div className="col-12">
																		<div className="section-head row" style={{ padding: '0px 10px !important', paddingLeft: '8px' }}>
																			<div style={{ alignItems: 'center', fontSize: '14px' }} className="col-md-8 col-6">
																				<div className="flex align-items-center" style={{ gap: '10px' }}>
																					<div>
																						{attachment?.extension == 'pdf' ? (
																							<PictureAsPdfOutlinedIcon style={{ fontSize: 24 }} />
																						) : (
																							<InsertPhotoOutlinedIcon style={{ fontSize: 24 }} />
																						)}
																					</div>
																					<div>
																						<div className="">
																							{
																								isMobile ? (
																									'Attachment'
																								) : (
																									attachment?.filename
																								)
																							}
																						</div>
																						<div className="text-gray-600" style={{ fontSize: '12px' }}>
																							{attachment?.file_size ? (
																								attachment?.file_size
																							) : (
																								'File size not available'
																							)}
																						</div>

																					</div>
																				</div>
																			</div>
																			<div className="actions col-md-4 col-6 flex align-items-center justify-end" style={{ gap: '8px' }}>
																				<button
																					type="button"
																					onClick={() => downloadAttachment(attachment)}
																					className="btn btn-primary btn-outlined-main"
																					style={{ minWidth: `${isMobile ? 'auto' : '110px'}` }}
																				>
																					<SettingsDownloadIcon height="16px" width="16px" />
																					
																					{ !isMobile && 'Download' }
																				</button>
																				<button
																					type="button"
																					className="btn btn-danger flex items-center"
																					onClick={() => removeAttachment(attachment?.id)}
																					style={{ gap: '5px' }}
																				>
																					<DeleteIcon height="14px" width="14px" />
																					{ !isMobile && 'Delete' }
																					
																				</button>
																				<div
																					className={`invoice-attachment-collapse-icon ${collapsedAttachments[index] ? 'collapsed' : ''}`}
																					onClick={() => toggleAttachmentCollapse(index)}
																				>
																					<LuChevronUp />
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
															{collapsedAttachments[index] && (
																<div className="card-body text-center" style={{ padding: '0px' }}>
																	{attachment?.extension == 'pdf' ? (
																		<PdfViewer src={attachment?.attachment_url + '#toolbar=0&navpanes=0&zoom=FitW'} />
																	) : (
																		<img src={attachment?.attachment_url} className="img-fluid" />
																	)}
																</div>
															)}
														</div>
													</div>
												</div>
											))
										)}

									</>		
								)
							}
						</div>
					)}

				</div>
			</div>
			<div className="col-12 col-md-4 col-lg-4 col-xl-3 inv-details">
				<div className="mt-20">
					<div className="est-detail-item">
						{!selectedEstimate ? (
							<>
								<div>
									<div style={{ width: '150px', marginBottom: '11px' }}>
										<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
									</div>
								</div>
								<div>
									<div style={{ width: '150px', marginBottom: '11px' }}>
										<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
									</div>
								</div>
							</>
						) : (
							<>
								<label htmlFor="inputName" className="est-labels">
									Currency & Rate
								</label>
								<p>
									{selectedEstimate?.currency?.toUpperCase()}, 1 ={' '}
									{selectedEstimate?.currency == 'eur'
										? `$ ${(
												(1 / selectedEstimate?.currency_rate?.currency_rates[1]?.rate) *
												selectedEstimate?.currency_rate?.currency_rates[2]?.rate
											).toFixed(4)}`
										: selectedEstimate?.currency == 'usd'
										? `€ ${(
												(1 / selectedEstimate?.currency_rate?.currency_rates[2]?.rate) *
												selectedEstimate?.currency_rate?.currency_rates[1]?.rate
											).toFixed(4)}`
										: selectedEstimate?.currency == 'aed'
										? `€ ${(
												(1 / selectedEstimate?.currency_rate?.currency_rates[0]?.rate) *
												selectedEstimate?.currency_rate?.currency_rates[1]?.rate
											).toFixed(4)}`
										: ''}
								</p>
							</>
						)}
					</div>
					{!selectedEstimate ? (
						<>
							<div className="est-detail-item">
								<div>
									<div style={{ width: '150px', marginBottom: '11px' }}>
										<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
									</div>
								</div>
								<div>
									<div style={{ width: '150px', marginBottom: '11px' }}>
										<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
									</div>
								</div>
							</div>
							<div className="est-detail-item">
								<div>
									<div style={{ width: '150px', marginBottom: '11px' }}>
										<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
									</div>
								</div>
								<div>
									<div style={{ width: '150px', marginBottom: '11px' }}>
										<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
									</div>
								</div>
							</div>
						</>
					) : (
						selectedEstimate?.master_status?.status_type_id == 2 ? (
							<>
								<div className="est-detail-item">
									<label htmlFor="inputName" className="est-labels">
										Transit
									</label>
									{
										selectedEstimate?.transit_company?.name ? (
											<Link to={`/contacts/${selectedEstimate?.transit_company?.id}`}>
												<PrivacyModeContent>
													{
														isMobile ? (
															`${selectedEstimate?.transit_company?.name}`
														) : (
															`${selectedEstimate?.transit_company?.name?.length > 30 ? selectedEstimate?.transit_company?.name.slice(0, 30) + '...' : selectedEstimate?.transit_company?.name}`
														)
													}
												</PrivacyModeContent>
											</Link>
										) : (
											<div className="text-gray-600">-----</div>
										)
									}			
								</div>
								<div className="est-detail-item">
									<label htmlFor="inputName" className="est-labels">
										Customer
									</label>

									<Link to={`/contacts/${selectedEstimate?.customer?.id}`}>
										<PrivacyModeContent notUserRestricted>
											{
												isMobile ? (
													selectedEstimate?.customer?.name
												) : (
													selectedEstimate?.customer?.name?.length > 21 ? selectedEstimate?.customer?.name.slice(0, 21) + '...' : selectedEstimate?.customer?.name
												)
											}
										</PrivacyModeContent>
									</Link>
								</div>
							</>
						) : (
							<>
								<div className="est-detail-item">
									<label htmlFor="inputName" className="est-labels">
										Transit
									</label>

									{
										selectedEstimate?.transit_company?.name ? (
											<Link to={`/contacts/${selectedEstimate?.transit_company?.id}`}>
												<PrivacyModeContent>
													{
														isMobile ? (
															`${selectedEstimate?.transit_company?.name}`
														) : (
															`${selectedEstimate?.transit_company?.name?.length > 30 ? selectedEstimate?.transit_company?.name.slice(0, 30) + '...' : selectedEstimate?.transit_company?.name}`
														)
													}
												</PrivacyModeContent>
											</Link>
										) : (
											<div className="text-gray-600">-----</div>				
										)
									}
								</div>
								<div className="est-detail-item">
									<label htmlFor="inputName" className="est-labels">
										Customer
									</label>

									<Link to={`/contacts/${selectedEstimate?.customer?.id}`}>
										<PrivacyModeContent>
											{
												isMobile ? (
													`${selectedEstimate?.customer?.name}`
												) : (
													`${selectedEstimate?.customer?.name?.length > 21 ? selectedEstimate?.customer?.name.slice(0, 21) + '...' : selectedEstimate?.customer?.name}`
												)
											}
										</PrivacyModeContent>
									</Link>
								</div>
							</>
						)
					)}

					{!selectedEstimate ? (
						<div className="est-detail-item">
							<div>
								<div style={{ width: '150px', marginBottom: '11px' }}>
									<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
								</div>
							</div>
							<div>
								<div style={{ width: '150px', marginBottom: '11px' }}>
									<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
								</div>
							</div>
						</div>
					) : (
						selectedEstimate?.master_status?.name != 'Credit Note' && (
							<div className="est-detail-item">
								<label htmlFor="inputName" className="est-labels">
									Sales Manager
								</label>

								<Link to={`/settings/user/${selectedEstimate?.sales_person?.id}`}>
									{selectedEstimate?.sales_person?.first_name} {selectedEstimate?.sales_person?.last_name}
								</Link>
							</div>
						)
					)}
					{selectedEstimate && (
						selectedEstimate?.is_draft != 1 &&
						selectedEstimate?.paid_status != 'Paid' &&
						selectedEstimate?.master_status?.name != 'Accepted' &&
						selectedEstimate?.master_status?.name != 'Completed' &&
						selectedEstimate?.master_status?.name != 'Paid' &&
						selectedEstimate?.master_status?.name != 'Invoiced' && (
							selectedEstimate?.master_status?.name != 'Invoiced' && selectedEstimate?.master_status?.name != 'Paid' && (
								<div className="mt20">
									<TimelineStep
										selectedEstimate={selectedEstimate}
										startDateParam={
											selectedEstimate?.transaction_type == 'Invoice'
												? selectedEstimate?.invoice_date
												: selectedEstimate?.start_date
										}
										endDateParam={
											selectedEstimate?.transaction_type == 'Invoice'
												? selectedEstimate?.invoice_due_date
												: selectedEstimate?.expires_at
										}
									/>
								</div>
							)
						)
					)}
					{!selectedEstimate ? (
						<div className="form-group mb-2 mt-3">
							<label htmlFor="inputName" className="est-labels">
								<div style={{ width: '100px', marginBottom: '4px' }}>
									<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
								</div>
							</label>

							<div>
								<div style={{ width: '100%', marginBottom: '14px' }}>
									<div>
										<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
									</div>
								</div>
								<div style={{ width: '110px', marginBottom: '14px' }}>
									<div>
										<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
									</div>
								</div>
								<div style={{ width: '100%', marginBottom: '14px' }}>
									<div>
										<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
									</div>
								</div>
							</div>
						</div>
					) : (
						<Notes
							notes={estimateRow?.notes}
							addNote={addNote}
							deleteNotePermission={[]}
							removeNote={removeNote}
							toggleNoteExpand={toggleNoteExpand}
							parentId={1}
							type="quotation"
						/>
					)}
				</div>
			</div>
			{confirmationDialog?.show && (
				<ActionConfirmationModal
					show={confirmationDialog?.show}
					message={confirmationDialog?.message}
					title={confirmationDialog?.title}
					customConfirmText={confirmationDialog?.customConfirm || 'Confirm'}
					customCancelText={confirmationDialog?.customCancel || 'Cancel'}
					customIcon={<PiInfoFill />}
					handleConfirm={confirmationDialog?.handleConfirm}
					handleClose={confirmationDialog?.handleClose}
				/>
			)}

			{openSendEmailPopup && !isMobile && (
				<SendEmailModal
					openPopup={openSendEmailPopup}
					selectedEstimate={selectedEstimate}
					handleClose={closeSendEmailPopup}
					sendEstimateEmail={handleSendEstimateEmail}
					sendingEstimate={sendingEstimate}
					selectedForSending={selectedForSending}
					disableStatus={false}
				/>
			)}

			{openSendEmailPopup && isMobile && (
				<SendEmailModalMobile
					openPopup={openSendEmailPopup}
					selectedEstimate={selectedEstimate}
					handleClose={closeSendEmailPopup}
					sendEstimateEmail={handleSendEstimateEmail}
					sendingEstimate={sendingEstimate}
					selectedForSending={selectedForSending}
					disableStatus={false}
				/>
			)}

			{showDeletePopup && (
				<DeleteConfirmation
					show={showDeletePopup}
					handleClose={handleCloseDeletePopup}
					handleDelete={handleDelete}
					title="Confirm"
					message={`${deleteMessage}`}
				/>
			)}
			{showDeleteInvoicePopup && (
				<DeleteConfirmation
					show={showDeleteInvoicePopup}
					handleClose={() => {
						setShowDeleteInvoicePopup(false);
					}}
					handleDelete={handleDeleteInvoice}
					title="Confirm"
					message={`Are you sure you want to delete invoice ${selectedEstimate?.invoice_number}? This action cannot be undone.`}
				/>
			)}
			{showDeleteQuotationPopup && (
				<DeleteConfirmation
					show={showDeleteQuotationPopup}
					handleClose={() => {
						setShowDeleteQuotationPopup(false);
					}}
					handleDelete={handleDeleteQuotation}
					title="Confirm"
					message={`Are you sure you want to delete quotation ${selectedEstimate?.estimation_number}? This action cannot be undone.`}
				/>
			)}
			{showDeleteCreditNotePopup && (
				<DeleteConfirmation
					show={showDeleteCreditNotePopup}
					handleClose={() => {
						setShowDeleteCreditNotePopup(false);
					}}
					handleDelete={handleDeleteCreditNote}
					title="Confirm"
					message={`Are you sure you want to delete credit note ${selectedEstimate?.invoice_number}? This action cannot be undone.`}
				/>
			)}


			{showCancelPopup && (
				<DeleteConfirmation
					show={showCancelPopup}
					handleClose={handleClose}
					handleDelete={handleCancel}
					title="Are you sure?"
					message={`By canceling, this ${salesType} cannot be rolled back. Do you want to proceed?`}
					customDeleteButtonText={`Yes, Cancel this ${
						salesType === 'estimate' ? 'Quotation' : salesType === 'invoice' ? 'Invoice' : 'Credit Note'
					}`}
				/>
			)}

			{showCompletePopup && (
				<ActionConfirmationModal
					show={showCompletePopup}
					message={`Are you sure you want to complete <br />invoice ${selectedEstimate?.invoice_number}?`}
					title={`${(selectedEstimate?.master_status?.name === 'Paid' || selectedEstimate?.master_status?.name === 'Credit Note') ? 'Complete' : 'Re-open'} ${selectedEstimate?.master_status?.name === 'Credit Note' ? 'Credit Note' : 'Invoice'}?`}
					customConfirmText={`Yes`}
					customCancelText={`Close`}
					customIcon={<PiInfoFill />}
					handleConfirm={() => {
						handleCompleteInvoice(selectedEstimate?.id);
					}}
					handleClose={() => {
						setShowCompletePopup(false);
					}}
					hasIsLoading={true}
					isLoading={completingInvoice}
				/>
			)}



			{showPurchaseOrderModal && (
				<PurchaseOrderModal
					openPopup={showPurchaseOrderModal}
					selectedEstimate={selectedEstimate}
					handleClose={closePurchaseOrderPopup}
					handleItems={purchaseOrderItems}
					handleCreatePurchaseOrder={() => {}}
				/>
			)}
			{showDeletePayment && (
				<DeleteConfirmation
					key="paymentDelete"
					show={showDeletePayment}
					handleClose={handleClose}
					handleDelete={handleDeletePayment}
					title="Confirm"
					message={`Are you sure you want to delete this payment?`}
					customDeleteButtonText={'Yes, Delete this payment'}
				/>
			)}
			{showChangeStatusModal && (
				<ChangeStatusMobileModal
					show={showChangeStatusModal}
					onClose={() => setShowChangeStatusModal(false)}
					onAccept={() => acceptOrder(selectedEstimate)}
					onBilled={() => billOrder(selectedEstimate)}
					onCancel={() => setShowCancelPopup(true)}
					canAccept={statusAllowedToAccept.includes(selectedEstimate?.master_status?.name)}
					canBilled={statusAllowedToAccept.includes(selectedEstimate?.master_status?.name)}
					canCancel={statusAllowedToCancel.includes(selectedEstimate?.master_status?.name)}
				/>
			)}

			{showDeleteAttachment && (
				<DeleteConfirmation
					show={showDeleteAttachment}
					handleClose={handleClose}
					handleDelete={handleDeleteAttachment}
					title="Confirm"
					message={`Are you sure you want to delete attachment?`}
				/>
			)}
		</div>
	);
};

export default EstimationDetails;
